// extracted by mini-css-extract-plugin
module.exports = {"section":"_3VRj-","sectionRelay":"_2yPl9","subTitle":"_1AR3j","descriptionContent":"_3mJZf","errorBox":"_Xrh5","errorTitle":"FdrtC","errorLink":"_1j0Gz"};